module.exports = __webpack_public_path__ + "img/vtex.bbe87ab.svg";